(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dietxp-cart-controller"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('dietxp-cart')) return;
  const VERSION = '3.0.1';
  const OPENERS = '[data-dxp-cart-open], #cart-icon-bubble, .cart-icon--drawer, side-drawer-opener[data-side-drawer="#Cart-Drawer"], [data-cart-drawer-toggle]';
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]));
  const safeURL = (value, image = false) => {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      const url = new URL(String(value || ''), location.origin);
      if (!['https:', 'http:'].includes(url.protocol) || (!image && url.origin !== location.origin)) return '';
      return url.href;
    } catch { return ''; }
  };
  class DietXPCartElement extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;
        if (window.DietXPCart?.element?.isConnected) { this.hidden = true; return; }
        const dialog = this.querySelector('[data-dxpc-dialog]');
        const configNode = this.querySelector('[data-dxpc-config]');
        if (!dialog || !configNode || typeof dialog.showModal !== 'function') return;
        try { this.controller = new CartSystem(this, dialog, JSON.parse(configNode.textContent)); }
        catch (error) { console.error('DietXP cart initialization failed', error.name); }
      });
    }
    disconnectedCallback() { this.controller?.destroy(); this.controller = null; }
  }
  class CartSystem {
    constructor(host, dialog, config) {
      this.host = host;
      this.dialog = dialog;
      this.config = config;
      this.root = config.root || '/';
      this.cart = null;
      this.pending = 0;
      this.tail = Promise.resolve();
      this.readPromise = null;
      this.error = '';
      this.dirty = true;
      this.invalidation = 0;
      this.noteDirty = false;
      this.noteRevision = 0;
      this.recommendationCache = new Map();
      this.recommendationToken = 0;
      this.forms = new WeakSet();
      this.native = new Map();
      this.abort = new AbortController();
      this.requests = new Set();
      this.dead = false;
      this.lastTrigger = null;
      this.externalTimer = 0;
      this.fields = {};
      ['panel','body','lines','empty','footer','total','count','status','notice','retry','savings','tax','discounts','note','note-wrap','save-note','shipping','shipping-copy','recommendations','recommendation-list','checkout','checkout-form'].forEach(key => {
        this.fields[key] = dialog.querySelector('[data-dxpc-' + key + ']') || dialog.querySelector('.dxpc__' + key);
      });
      for (const name of ['--dxpc-width','--dxpc-accent','--dxpc-accent-text']) dialog.style.setProperty(name, host.style.getPropertyValue(name));
      document.body.appendChild(dialog);
      const snapshot = async promise => structuredClone(await promise);
      this.publicAPI = Object.freeze({
        version: VERSION, element: dialog,
        open: trigger => snapshot(this.open(trigger)),
        close: () => this.close(),
        refresh: () => snapshot(this.refresh()),
        add: (input, options) => snapshot(this.add(input, options)),
        change: (key, quantity) => snapshot(this.change(key, quantity)),
        updateNote: note => snapshot(this.updateNote(note)),
        state: () => ({ cart: this.cart ? structuredClone(this.cart) : null, pending: this.pending, error: this.error, open: dialog.open, version: VERSION }),
        ensure: () => Promise.resolve(!this.dead && dialog.isConnected)
      });
      window.DietXPCart = this.publicAPI;
      window.BaoCartDrawer = this.publicAPI;
      this.bind();
      this.cleanNative();
      this.bridgeNative();
      if (config.bridgeNative) document.documentElement.classList.add('dxpc-ready');
      this.emit('ready', { version: VERSION });
    }
    label(key, values = {}) {
      let text = this.config.labels[key] || key;
      for (const [name, value] of Object.entries(values)) text = text.split('{' + name + '}').join(String(value));
      return text;
    }
    money(value) {
      const amount = Number(value || 0) / 100;
      const currency = this.cart?.currency || this.config.currency || 'INR';
      try { return new Intl.NumberFormat(this.config.locale || 'en-IN', { style:'currency', currency, minimumFractionDigits: Number.isInteger(amount) ? 0 : undefined }).format(amount); }
      catch { return currency + ' ' + amount.toFixed(2); }
    }
    emit(type, detail = {}) {
      document.dispatchEvent(new CustomEvent('dietxp:cart:' + type, { detail: { ...detail, source:'dietxp-cart', version:VERSION } }));
    }
    on(target, type, handler, options = {}) { target.addEventListener(type, handler, { ...options, signal:this.abort.signal }); }
    status(message = '', retry = false) {
      this.fields.status.textContent = message;
      this.fields.notice.hidden = !message;
      this.fields.retry.hidden = !retry;
      this.fields.notice.querySelector('a').hidden = !retry;
    }
    syncBusy() {
      const busy = this.pending > 0;
      this.fields.body.setAttribute('aria-busy', String(busy));
      this.dialog.querySelectorAll('[data-dxpc-mutate], [data-dxpc-save-note]').forEach(el => { el.disabled = busy; });
      this.fields.checkout.disabled = busy || !this.cart?.item_count || this.dirty;
      this.fields.checkout.setAttribute('aria-busy', String(busy));
      this.emit('state', { pending:this.pending });
    }
    enqueue(kind, task) {
      if (this.pending === 0) {
        const node = document.activeElement;
        this.pendingFocus = this.dialog.open && this.dialog.contains(node) ? { node, key:node.closest('[data-dxpc-line]')?.dataset.dxpcLine, role:node.dataset?.focus } : null;
      }
      this.pending++;
      this.syncBusy();
      const result = this.tail.then(async () => {
        if (this.dead) throw new Error(this.label('update_error'));
        this.error = '';
        this.status(this.label(kind === 'read' ? 'loading' : 'updating'));
        try {
          const cart = await task();
          if (!this.dead) this.status(kind === 'read' ? '' : this.label(kind === 'add' ? 'added' : kind === 'note' ? 'note_saved' : 'updated'));
          return cart;
        } catch (error) {
          if (this.dead) throw error;
          if (kind !== 'read') {
            this.dirty = true;
            try { await this.readConfirmedCart(); } catch {}
          }
          this.error = error.message || this.label('update_error');
          this.status(this.error, true);
          this.emit('error', { operation:kind, message:this.error, uncertain:Boolean(error.uncertain) });
          throw error;
        }
      }).finally(() => {
        this.pending--;
        if (this.dead) return;
        this.syncBusy();
        if (this.pending === 0) {
          const saved = this.pendingFocus;
          if (saved && this.dialog.open && (document.activeElement === document.body || document.activeElement === saved.node)) {
            const line = Array.from(this.fields.lines.children).find(line => line.dataset.dxpcLine === saved.key);
            const target = saved.node.isConnected ? saved.node : saved.role ? line?.querySelector('[data-focus="' + saved.role + '"]') : null;
            (target || this.dialog.querySelector('button[data-dxpc-close]')).focus({ preventScroll:true });
          }
          this.pendingFocus = null;
        }
      });
      this.tail = result.catch(() => {});
      return result;
    }
    async request(path, data) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 12000);
      this.requests.add(controller);
      const post = data !== undefined;
      try {
        const headers = { Accept:'application/json' };
        const body = data instanceof FormData ? data : post ? JSON.stringify(data) : undefined;
        if (post && !(data instanceof FormData)) headers['Content-Type'] = 'application/json';
        const response = await fetch(this.root + path, { method:post ? 'POST' : 'GET', credentials:'same-origin', cache:'no-store', headers, body, signal:controller.signal });
        const payload = await response.json().catch(() => null);
        if (!response.ok || !payload || payload.status >= 400) {
          const error = new Error(typeof payload?.description === 'string' ? payload.description : this.label(post ? 'update_error' : 'load_error'));
          error.uncertain = post && (response.status >= 500 || !payload);
          if (error.uncertain) error.message = this.label('uncertain');
          error.known = true;
          throw error;
        }
        return payload;
      } catch (error) {
        if (post && !error.known) { error.uncertain = true; error.message = this.label('uncertain'); }
        else if (!post && !error.known) error.message = this.label('load_error');
        throw error;
      } finally { clearTimeout(timeout); this.requests.delete(controller); }
    }
    async readConfirmedCart() {
      for (let attempt = 0; attempt < 3; attempt++) {
        const generation = this.invalidation;
        const cart = await this.request('cart.js');
        if (generation !== this.invalidation) continue;
        this.commit(cart);
        return this.cart;
      }
      this.dirty = true;
      throw new Error(this.label('load_error'));
    }
    async commitResponse(cart, generation) {
      if (generation !== this.invalidation) return this.readConfirmedCart();
      this.commit(cart);
      return this.cart;
    }
    refresh() {
      if (this.readPromise) return this.readPromise;
      this.dirty = true;
      this.readPromise = this.enqueue('read', () => this.readConfirmedCart()).finally(() => { this.readPromise = null; });
      return this.readPromise;
    }
    add(input, options = {}) {
      let payload = input instanceof HTMLFormElement ? new FormData(input) : input;
      if (payload instanceof FormData) {
        const copy = new FormData();
        for (const [key,value] of payload.entries()) copy.append(key,value);
        payload = copy;
      } else if (payload && typeof payload === 'object') payload = structuredClone(payload);
      const wantOpen = options.open ?? this.config.autoOpen;
      if (wantOpen) this.show(options.trigger);
      return this.enqueue('add', async () => {
        if (!payload || (!(payload instanceof FormData) && !payload.id && !Array.isArray(payload.items))) throw new Error(this.label('update_error'));
        await this.request('cart/add.js', payload);
        try { await this.readConfirmedCart(); }
        catch (error) { error.message = this.label('added_refresh_error'); throw error; }
        this.broadcast();
        this.emit('added', { cart:structuredClone(this.cart) });
        return this.cart;
      });
    }
    change(key, quantity) {
      return this.enqueue('change', async () => {
        const item = this.cart?.items.find(item => item.key === key);
        if (!item) throw new Error(this.label('stale_line'));
        const rule = item.quantity_rule || {};
        const min = Math.max(1, Number(rule.min) || 1);
        const increment = Math.max(1, Number(rule.increment) || 1);
        if (typeof quantity !== 'number' && (typeof quantity !== 'string' || !/^\d+$/.test(quantity.trim()))) throw new Error(this.label('invalid_quantity'));
        const value = Number(quantity);
        if (!Number.isInteger(value) || value < 0 || (value > 0 && (value < min || (value - min) % increment !== 0 || (rule.max != null && value > Number(rule.max))))) throw new Error(this.label('invalid_quantity'));
        const generation = this.invalidation;
        await this.commitResponse(await this.request('cart/change.js', { id:key, quantity:value }), generation);
        this.broadcast();
        return this.cart;
      });
    }
    updateNote(note) {
      const revision = this.noteRevision;
      return this.enqueue('note', async () => {
        const generation = this.invalidation;
        const next = await this.request('cart/update.js', { note:String(note ?? '').slice(0,5000) });
        if (revision === this.noteRevision) this.noteDirty = false;
        await this.commitResponse(next, generation);
        this.broadcast();
        return this.cart;
      });
    }
    commit(cart) {
      if (this.dead) return;
      if (!Array.isArray(cart?.items) || !Number.isFinite(Number(cart.total_price)) || !Number.isFinite(Number(cart.item_count))) throw new Error(this.label('load_error'));
      this.cart = cart;
      this.dirty = false;
      this.render();
      this.emit('change', { cart:structuredClone(cart) });
      if (this.dialog.open) this.loadRecommendations();
    }
    badge() {
      const count = this.cart?.item_count || 0;
      this.fields.count.textContent = count > 99 ? '99+' : String(count);
      document.querySelectorAll('[data-dxp-cart-count], [data-cart-count], .cart-count-bubble, .dietxp-live-cart-count, [data-dxpc-badge]').forEach(el => {
        if (this.dialog.contains(el)) return;
        const visual = el.querySelector('[aria-hidden="true"]');
        const accessible = el.querySelector('.visually-hidden, .sr-only');
        (visual || el).textContent = count > 99 ? '99+' : String(count);
        if (visual && accessible) accessible.textContent = this.label('count', { count });
        el.hidden = count === 0;
      });
      const icon = document.getElementById('cart-icon-bubble');
      if (!icon) return;
      icon.setAttribute('aria-label', this.label('count', { count }));
      if (count > 0 && !icon.querySelector('.cart-count-bubble, [data-cart-count], .dietxp-live-cart-count, [data-dxpc-badge]')) {
        const badge = document.createElement('span');
        badge.dataset.dxpcBadge = '';
        badge.setAttribute('aria-hidden','true');
        badge.textContent = count > 99 ? '99+' : String(count);
        icon.appendChild(badge);
      }
    }
    discounts(allocations, cartLevel = false) {
      return (allocations || []).map(allocation => {
        const title = allocation.discount_application?.title || allocation.title;
        const amount = cartLevel ? allocation.total_allocated_amount : allocation.amount;
        return title ? `<div class="dxpc__discount"><span>${esc(title)}</span><span>−${esc(this.money(amount))}</span></div>` : '';
      }).join('');
    }
    line(item) {
      const title = item.product_title || item.title || this.label('product');
      const image = safeURL(item.featured_image?.url || item.image, true);
      const url = safeURL(item.url) || this.root + 'cart';
      const key = esc(item.key);
      const price = Number(item.final_line_price ?? item.line_price ?? 0);
      const original = Number(item.original_line_price ?? price);
      const rule = item.quantity_rule || {};
      const increment = Math.max(1, Number(rule.increment) || 1);
      const props = Object.entries(item.properties || {}).filter(([key,value]) => !key.startsWith('_') && value != null && value !== '').map(([key,value]) => `<dt>${esc(key)}</dt><dd>${esc(value)}</dd>`).join('');
      const plan = item.selling_plan_allocation?.selling_plan?.name;
      const locked = Boolean(item.parent_relationship);
      return `<article class="dxpc__line" data-dxpc-line="${key}">
        <a class="dxpc__image" href="${esc(url)}" aria-label="${esc(title)}" data-focus="image">${image ? `<img src="${esc(image)}" alt="${esc(title)}" width="144" height="160" loading="lazy">` : ''}</a>
        <div class="dxpc__item">
          <a class="dxpc__line-title" href="${esc(url)}" data-focus="title">${esc(title)}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="dxpc__variant">${esc(item.variant_title)}</p>` : ''}
          ${plan ? `<p class="dxpc__plan">${esc(plan)}</p>` : ''}
          ${props ? `<dl class="dxpc__properties">${props}</dl>` : ''}
          <div class="dxpc__price"><span>${esc(this.money(price))}</span>${original > price ? `<s>${esc(this.money(original))}</s>` : ''}</div>
          <div class="dxpc__discounts">${this.discounts(item.line_level_discount_allocations)}</div>
          ${locked ? '' : `<div class="dxpc__actions"><div class="dxpc__quantity">
            <button type="button" data-dxpc-mutate data-dxpc-dec data-focus="decrease" aria-label="${esc(this.label('decrease',{ product:title }))}">−</button>
            <input type="number" inputmode="numeric" min="0" step="${increment}" ${rule.max != null ? `max="${esc(rule.max)}"` : ''} value="${item.quantity}" data-dxpc-quantity data-dxpc-mutate data-focus="quantity" aria-label="${esc(this.label('quantity',{ product:title }))}">
            <button type="button" data-dxpc-mutate data-dxpc-inc data-focus="increase" aria-label="${esc(this.label('increase',{ product:title }))}">+</button>
          </div><button type="button" class="dxpc__text-button" data-dxpc-mutate data-dxpc-remove data-focus="remove" aria-label="${esc(this.label('remove') + ': ' + title)}">${esc(this.label('remove'))}</button></div>`}
        </div>
      </article>`;
    }
    render() {
      const active = document.activeElement;
      const focusKey = this.fields.lines.contains(active) ? active.closest('[data-dxpc-line]')?.dataset.dxpcLine : null;
      const focusRole = active.dataset?.focus;
      this.fields.lines.innerHTML = this.cart.items.map(item => this.line(item)).join('');
      this.fields.empty.hidden = this.cart.item_count > 0;
      this.fields.footer.hidden = this.cart.item_count === 0;
      this.fields.lines.hidden = this.cart.item_count === 0;
      if (this.fields['note-wrap']) this.fields['note-wrap'].hidden = this.cart.item_count === 0;
      if (this.fields.note && !this.noteDirty) this.fields.note.value = this.cart.note || '';
      this.fields.total.textContent = this.money(this.cart.total_price);
      const savings = Number(this.cart.total_discount ?? Math.max(0, this.cart.original_total_price - this.cart.total_price));
      this.fields.savings.hidden = !(savings > 0);
      this.fields.savings.textContent = this.label('savings', { amount:this.money(savings) });
      this.fields.tax.textContent = this.label(this.cart.taxes_included ? 'tax_included' : 'tax_excluded');
      this.fields.discounts.innerHTML = this.discounts(this.cart.cart_level_discount_applications, true);
      this.renderShipping();
      this.badge();
      this.renderRecommendations();
      if (focusKey && focusRole && this.dialog.open) {
        const line = Array.from(this.fields.lines.children).find(line => line.dataset.dxpcLine === focusKey);
        (line?.querySelector('[data-focus="' + focusRole + '"]') || this.dialog.querySelector('button[data-dxpc-close]')).focus({ preventScroll:true });
      }
      this.syncBusy();
    }
    renderShipping() {
      const threshold = Number(this.config.shippingThreshold) || 0;
      const visible = threshold > 0 && this.cart?.item_count > 0 && this.cart.requires_shipping && this.config.shippingCurrency === this.cart.currency;
      this.fields.shipping.hidden = !visible;
      if (!visible) return;
      const remaining = Math.max(0, threshold - this.cart.total_price);
      this.fields['shipping-copy'].textContent = remaining > 0 ? this.label('shipping_remaining', { amount:this.money(remaining) }) : this.label('shipping_unlocked');
      this.fields.shipping.querySelector('progress').value = Math.min(100, this.cart.total_price / threshold * 100);
    }
    async loadRecommendations() {
      if (!this.config.showRecommendations || !this.cart?.item_count) { this.fields.recommendations.hidden = true; return; }
      const seed = this.cart.items[0]?.product_id;
      if (!seed) return;
      const cacheKey = [seed,this.root,this.cart.currency].join(':');
      this.recommendationKey = cacheKey;
      if (this.recommendationCache.has(cacheKey)) { this.renderRecommendations(); return; }
      if (this.recommendationPending === cacheKey) return;
      this.recommendationPending = cacheKey;
      const token = ++this.recommendationToken;
      try {
        const data = await this.request('recommendations/products.json?product_id=' + encodeURIComponent(seed) + '&limit=10&intent=related');
        if (this.dead) return;
        this.recommendationCache.set(cacheKey, Array.isArray(data.products) ? data.products : []);
        if (token === this.recommendationToken) this.renderRecommendations();
      } catch { if (token === this.recommendationToken) this.fields.recommendations.hidden = true; }
      finally { if (this.recommendationPending === cacheKey) this.recommendationPending = null; }
    }
    renderRecommendations() {
      const inCart = new Set((this.cart?.items || []).map(item => String(item.product_id)));
      const products = (this.recommendationCache.get(this.recommendationKey) || []).filter(product => product.available !== false && !inCart.has(String(product.id))).slice(0, Number(this.config.recommendationLimit) || 4);
      const visible = this.config.showRecommendations && this.cart?.item_count > 0 && products.length > 0;
      this.fields.recommendations.hidden = !visible;
      if (!visible) return;
      const signature = this.recommendationKey + ':' + products.map(product => product.id + ':' + product.price).join(':');
      if (this.recommendationSignature === signature) return;
      this.recommendationSignature = signature;
      this.fields['recommendation-list'].innerHTML = products.map(product => {
        const variants = product.variants || [];
        const simple = variants.length === 1 && variants[0].available !== false && !product.requires_selling_plan && !product.selling_plan_groups?.length;
        const url = safeURL(product.url) || this.root + 'collections/all';
        const image = safeURL(typeof product.featured_image === 'string' ? product.featured_image : product.featured_image?.url, true);
        return `<article class="dxpc__recommendation"><a href="${esc(url)}">${image ? `<img src="${esc(image)}" alt="${esc(product.title)}" width="240" height="224" loading="lazy">` : ''}<span class="dxpc__recommendation-title">${esc(product.title)}</span></a><span class="dxpc__recommendation-price">${esc(this.money(product.price))}</span>${simple ? `<button type="button" class="dxpc__recommendation-action" data-dxpc-mutate data-dxpc-add="${esc(variants[0].id)}">${esc(this.label('add'))}</button>` : `<a class="dxpc__recommendation-action" href="${esc(url)}">${esc(this.label('options'))}</a>`}</article>`;
      }).join('');
      this.syncBusy();
    }
    cleanNative() {
      if (!this.config.bridgeNative) return;
      let wasOpen = false;
      document.querySelectorAll('cart-drawer, #Cart-Drawer').forEach(el => {
        wasOpen ||= el.matches('[open],.open,.active,.is-open');
        el.removeAttribute('open');
        el.classList.remove('open','active','animate','is-open');
      });
      if (wasOpen) {
        if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus();
        document.body.classList.remove('overflow-hidden');
        document.documentElement.removeAttribute('scroll-lock');
      }
    }
    bridgeNative() {
      if (!this.config.bridgeNative || this.dead) return;
      document.querySelectorAll('cart-drawer').forEach(el => {
        if (this.native.has(el)) return;
        const original = el.open;
        const bridge = trigger => { this.invalidate(); return this.open(trigger); };
        const observer = new MutationObserver(() => {
          if (!this.dead && el.matches('[open],.open,.active,.is-open')) this.cleanNative();
        });
        observer.observe(el,{ attributes:true, attributeFilter:['class','open'] });
        this.native.set(el, { original, bridge, observer, own:Object.hasOwn(el,'open') });
        el.open = bridge;
      });
    }
    show(trigger) {
      if (this.dialog.open || this.dead) return;
      this.lastTrigger = trigger instanceof HTMLElement ? trigger : document.activeElement;
      this.cleanNative();
      this.dialog.hidden = false;
      this.dialog.showModal();
      document.documentElement.classList.add('dxpc-locked');
      document.body.classList.add('dxpc-locked');
      this.dialog.querySelector('button[data-dxpc-close]').focus({ preventScroll:true });
      this.emit('open');
    }
    async open(trigger) {
      this.show(trigger);
      try { await this.refresh(); } catch {}
      return this.cart;
    }
    close() {
      const wasOpen = this.dialog.open;
      if (wasOpen) this.dialog.close();
      this.dialog.hidden = true;
      document.documentElement.classList.remove('dxpc-locked');
      document.body.classList.remove('dxpc-locked');
      this.cleanNative();
      if (this.lastTrigger?.isConnected && !this.dialog.contains(this.lastTrigger)) this.lastTrigger.focus({ preventScroll:true });
      this.lastTrigger = null;
      if (wasOpen) this.emit('close');
    }
    broadcast() {
      try { localStorage.setItem('dietxp:cart:revision', Date.now() + ':' + Math.random()); } catch {}
    }
    invalidate() {
      this.invalidation++;
      this.dirty = true;
      this.syncBusy();
    }
    externalRefresh(open = false) {
      if (this.dead) return;
      this.invalidate();
      if (open) this.show();
      clearTimeout(this.externalTimer);
      this.externalTimer = setTimeout(() => { this.refresh().catch(() => {}); }, 80);
    }
    async submit(form, submitter) {
      if (this.forms.has(form)) return;
      this.forms.add(form);
      const button = submitter || form.querySelector('[type="submit"]');
      const wasDisabled = button?.disabled;
      const oldBusy = form.getAttribute('aria-busy');
      let feedback = form.querySelector('[data-dxp-cart-status]');
      if (!feedback) {
        feedback = document.createElement('p');
        feedback.dataset.dxpCartStatus = '';
        feedback.className = 'dxpc-form-status';
        feedback.setAttribute('role','status');
        feedback.setAttribute('aria-live','polite');
        form.appendChild(feedback);
      }
      feedback.textContent = this.label('updating');
      const data = new FormData(form, submitter || undefined);
      if (button) button.disabled = true;
      form.setAttribute('aria-busy','true');
      try {
        await this.add(data, { trigger:button });
        feedback.textContent = this.label('added');
        this.emit('form-success', { form });
      } catch {
        feedback.textContent = this.error;
        this.show(button);
        this.emit('form-error', { form, message:this.error });
      } finally {
        this.forms.delete(form);
        if (button) button.disabled = wasDisabled;
        if (oldBusy == null) form.removeAttribute('aria-busy'); else form.setAttribute('aria-busy',oldBusy);
      }
    }
    bind() {
      this.on(document,'click', event => {
        const target = event.target instanceof Element ? event.target : event.target?.parentElement;
        if (!target || target.closest('[data-dxp-cart-ignore]')) return;
        const opener = target.closest(OPENERS);
        if (opener) { event.preventDefault(); event.stopImmediatePropagation(); this.open(opener); }
      }, { capture:true });
      this.on(document,'submit', event => {
        const form = event.target;
        if (!this.config.captureForms || !(form instanceof HTMLFormElement) || form.closest('[data-dxp-cart-ignore]') || this.dialog.contains(form)) return;
        const submitter = event.submitter;
        const action = new URL(submitter?.hasAttribute('formaction') ? submitter.formAction : form.action,location.href);
        const method = submitter?.hasAttribute('formmethod') ? submitter.formMethod : form.method;
        if (method.toLowerCase() !== 'post') return;
        if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(action.pathname) || !form.elements.namedItem('id')) return;
        if (event.submitter?.name === 'checkout' || event.submitter?.closest('[data-dxp-cart-ignore]')) return;
        event.preventDefault(); event.stopImmediatePropagation();
        this.submit(form,event.submitter);
      }, { capture:true });
      this.on(this.dialog,'click', event => {
        const target = event.target instanceof Element ? event.target : event.target?.parentElement;
        if (!target) return;
        if (target.closest('[data-dxpc-close]')) { this.close(); return; }
        if (target.closest('[data-dxpc-retry]')) { this.refresh().catch(() => {}); return; }
        if (target.closest('[data-dxpc-save-note]')) { this.updateNote(this.fields.note.value).catch(() => {}); return; }
        const add = target.closest('[data-dxpc-add]');
        if (add) { this.add({ items:[{ id:add.dataset.dxpcAdd, quantity:1 }] }, { open:false }).catch(() => {}); return; }
        const line = target.closest('[data-dxpc-line]');
        const item = this.cart?.items.find(item => item.key === line?.dataset.dxpcLine);
        if (!item || this.pending) return;
        const step = Number(item.quantity_rule?.increment) || 1;
        const min = Number(item.quantity_rule?.min) || 1;
        let quantity;
        if (target.closest('[data-dxpc-inc]')) quantity = item.quantity + step;
        if (target.closest('[data-dxpc-dec]')) quantity = item.quantity - step < min ? 0 : item.quantity - step;
        if (target.closest('[data-dxpc-remove]')) quantity = 0;
        if (quantity !== undefined) this.change(item.key,quantity).catch(() => {});
      });
      this.on(this.dialog,'change', event => {
        if (event.target.matches('[data-dxpc-quantity]')) this.change(event.target.closest('[data-dxpc-line]').dataset.dxpcLine,event.target.value).catch(() => {});
      });
      if (this.fields.note) this.on(this.fields.note,'input', () => { this.noteDirty = true; this.noteRevision++; });
      this.on(this.fields['checkout-form'],'submit', async event => {
        if (this.pending || this.dirty) { event.preventDefault(); return; }
        if (!this.noteDirty) return;
        event.preventDefault();
        try { await this.updateNote(this.fields.note.value); if (!this.noteDirty && !this.dead && this.dialog.open) this.fields['checkout-form'].requestSubmit(this.fields.checkout); } catch {}
      });
      this.on(this.dialog,'cancel', event => { event.preventDefault(); this.close(); });
      this.on(this.dialog,'close', () => { if (!this.dialog.open) this.close(); });
      this.on(this.dialog,'keydown', event => {
        if (event.key !== 'Tab' || !this.dialog.open) return;
        const controls = Array.from(this.dialog.querySelectorAll('a[href],button,input,textarea,summary,[tabindex]')).filter(el => !el.disabled && el.tabIndex >= 0 && el.getClientRects().length);
        const first = controls[0], last = controls.at(-1);
        if ((event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last)) { event.preventDefault(); (event.shiftKey ? last : first)?.focus({ preventScroll:true }); }
      });
      ['cart:updated','bao:cart:updated','cart:refresh','cart-update'].forEach(type => this.on(document,type,event => {
        if (event.detail?.source === 'dietxp-cart') return;
        this.externalRefresh(this.config.autoOpen && (type === 'cart:updated' || type === 'bao:cart:updated'));
      }));
      this.on(document,'dietxp:cart:refresh', event => { if (event.detail?.source !== 'dietxp-cart') this.externalRefresh(Boolean(event.detail?.open)); });
      this.on(window,'storage', event => { if (event.key === 'dietxp:cart:revision') this.externalRefresh(); });
      this.on(window,'pageshow', event => { if (event.persisted) { this.close(); this.externalRefresh(); } });
      this.on(document,'visibilitychange', () => { if (document.visibilityState === 'visible') this.externalRefresh(); });
      this.on(document,'shopify:section:load', () => this.bridgeNative());
      customElements.whenDefined('cart-drawer').then(() => this.bridgeNative());
    }
    destroy() {
      if (this.dead) return;
      this.close();
      this.dead = true;
      clearTimeout(this.externalTimer);
      this.abort.abort();
      this.requests.forEach(controller => controller.abort());
      for (const [el, saved] of this.native) {
        saved.observer.disconnect();
        if (el.open === saved.bridge) { if (saved.own) el.open = saved.original; else delete el.open; }
      }
      this.native.clear();
      this.dialog.remove();
      if (window.DietXPCart === this.publicAPI) delete window.DietXPCart;
      if (window.BaoCartDrawer === this.publicAPI) delete window.BaoCartDrawer;
      document.documentElement.classList.remove('dxpc-ready');
      this.emit('destroy');
      const next = document.querySelector('dietxp-cart');
      if (next?.isConnected && next !== this.host) { next.hidden = false; next.connectedCallback(); }
    }
  }
  customElements.define('dietxp-cart', DietXPCartElement);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["multi-level-category"] && !Shopify.designMode) return;
  try {
    var first = true;

  function getCategories(root) {
    var result = [];
    var lis = root.querySelectorAll(':scope > li');
    lis.forEach(function (li) {
      var link = li.querySelector(':scope > a');
      var childrenUl = li.querySelector(':scope > ul');
      var node = {
        link: link ? link.getAttribute('href') : '',
        title: link ? link.innerHTML : '',
        children: childrenUl ? getCategories(childrenUl) : [],
      };
      result.push(node);
    });
    return result;
  }

  function setActive() {
    var result = [];
    var curLi = document.querySelector('nav#navPages > ul .active');
    if (!curLi || curLi.parentElement == null) return false;
    var index = Array.from(curLi.parentElement.children).indexOf(curLi);
    if (index === -1) return false;
    result.push(index);

    curLi = curLi.parentElement.parentElement;
    if (curLi && curLi.id !== 'navPages') {
      index = Array.from(curLi.parentElement.children).indexOf(curLi);
      result.push(index);
      curLi = curLi.parentElement.parentElement;
      if (curLi && curLi.id !== 'navPages') {
        index = Array.from(curLi.parentElement.children).indexOf(curLi);
        result.push(index);
      }
    }
    return result;
  }

  function buildSelect(level, level_List) {
    for (var i = level; i <= 4; i++) {
      var ul = document.querySelector('#multi-category_select-level-' + i + ' ul');
      if (ul) {
        ul.querySelectorAll('li[data-value]').forEach((li) => li.remove());
      }
    }
    var container = document.querySelector('#multi-category_select-level-' + level + ' ul');
    if (!container) return;
    for (var i = 0; i < level_List.length; i++) {
      var li = document.createElement('li');
      li.setAttribute('data-value', i);
      li.textContent = level_List[i].title.trim();
      li.addEventListener(
        'click',
        (function (lvl, idx) {
          return function () {
            changeOption(lvl, idx);
          };
        })(level, i)
      );
      container.appendChild(li);
    }
  }

  function changeOptionAll(level) {
    var ul = document.querySelector('#multi-category_select-level-' + level + ' ul');
    if (!ul) return;
    ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
    var select_option = ul.querySelector('li:nth-child(1)').innerHTML;
    var label = document.querySelector('#multi-category_select-level-' + level).previousElementSibling;
    label.innerHTML = select_option;
  }

  function changeOption(level, num) {
    if (num != null) {
      var redirect = false;
      var selector = '#multi-category_select-level-' + level + ' ul li[data-value="' + num + '"]';
      var activeLi = document.querySelector(selector);
      if (activeLi && !activeLi.classList.contains('active')) {
        redirect = true;
      }
      var ul = document.querySelector('#multi-category_select-level-' + level + ' ul');
      ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
      ul.querySelectorAll('li').forEach(function (li) {
        if (li.getAttribute('data-value') == num) {
          li.classList.add('active');
          document.querySelector('#multi-category_select-level-' + level).previousElementSibling.textContent =
            li.textContent;
        }
      });

      resetDrop(level);

      var level_List = list;
      for (var i = 1; i <= level; i++) {
        var active = document.querySelector('#multi-category_select-level-' + i + ' ul .active');
        if (active) {
          var index = parseInt(active.getAttribute('data-value'));
          if (level_List[index] !== undefined) {
            level_List = level_List[index].children;
          }
        }
      }

      if (level == 3 && redirect == true) {
        document.querySelector('#multi-category_select-browse').click();
      }

      level = parseInt(level) + 1;
      buildSelect(level, level_List);

      if (level_List.length && first == false) {
        var loading = document.querySelector('.multi-category_filter .loading');
        loading.style.display = 'block';
        setTimeout(function () {
          document.querySelector('#multi-category_select-level-' + level).classList.add('open');
          loading.style.display = 'none';
        }, 300);
      }
    }
  }

  function resetDrop(num) {
    for (var i = num + 1; i <= list.length; i++) {
      var ul = document.querySelector('#multi-category_select-level-' + i + ' ul');
      if (!ul) continue;
      var select_option = ul.querySelector('li:nth-child(1)') ? ul.querySelector('li:nth-child(1)').innerHTML : '';
      var label = document.querySelector('#multi-category_select-level-' + i).previousElementSibling;
      label.innerHTML = select_option;
      ul.innerHTML = '<li onclick="changeOptionAll(' + i + ')">' + select_option + '</li>';
    }
  }

  var list = getCategories(document.querySelector('nav#navPages > ul'));

  function MultiCategory() {
    if (!document.querySelector('.multi-category')) {
      return;
    }

    buildSelect(1, list);

    var level = 1;
    document.cookie = 'multiLevelCategory=; path=/;';

    var cookie = document.cookie.split('; ').find((row) => row.startsWith('multiLevelCategory='));
    if (cookie && cookie.split('=')[1] != '') {
      var active = cookie.split('=')[1].split(',');
      for (var i = 0; i < active.length; i++) {
        changeOption(level, active[i]);
        level++;
      }
      document.querySelector('.multi-category_filter .loading').style.display = 'none';
      document.querySelectorAll('.dropdown-up').forEach((el) => el.classList.remove('open'));
    }

    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('da-force-up')) {
        var dropdown = e.target.parentElement.querySelector('.dropdown-up');
        var isOpen = dropdown.classList.contains('open');
        document.querySelectorAll('.dropdown-up').forEach((el) => el.classList.remove('open'));
        if (!isOpen) dropdown.classList.add('open');
      }
    });

    window.addEventListener('click', function (e) {
      var container = document.querySelectorAll('.da-force-up');
      container.forEach(function (el) {
        if (el !== e.target && !el.contains(e.target)) {
          var dropdown = el.nextElementSibling;
          if (dropdown && dropdown.classList.contains('dropdown-up')) {
            dropdown.classList.remove('open');
          }
        }
      });
    });

    document.querySelector('#multi-category_select-browse').addEventListener('click', function () {
      var level_List = list;
      var index = 0,
        url = '';
      var menu = [];
      for (var i = 1; i <= 3; i++) {
        var active = document.querySelector('#multi-category_select-level-' + i + ' ul .active');
        if (active) {
          index = parseInt(active.getAttribute('data-value'));
          if (!isNaN(index)) {
            menu.push(index);
            url = level_List[index].link;
            if (level_List[index].children.length) {
              level_List = level_List[index].children;
            }
          }
        }
      }
      document.cookie = 'multiLevelCategory=' + menu.join(',') + '; path=/; max-age=' + 60 * 60 * 24;
      location.href = url;
    });

    document.querySelector('#multi-category_clear-select').addEventListener('click', function () {
      resetDrop(1);
      var ul = document.querySelector('#multi-category_select-level-1 ul');
      var select_option = ul.querySelector('li:nth-child(1)').innerHTML;
      document.querySelector('#multi-category_select-level-1').previousElementSibling.innerHTML = select_option;
      ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
    });

    first = false;
  }

  window.addEventListener('load', () => {
    MultiCategory();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["social-share-button"] && !Shopify.designMode) return;
  try {
    class ShareButtonProduct extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        shareButton: this.querySelector('button'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input'),
        content: this.querySelector('.share-button__product'),
        copyButton: this.querySelector('.button-copy')
      };

      if (this.elements.shareButton) {
        this.elements.shareButton.addEventListener('click', this.toggleDetails.bind(this));
      }
      if (this.elements.copyButton) {
        this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
      }
    }

    toggleDetails(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();
      if (!this.elements.urlInput) return;

      const url = this.elements.urlInput.getAttribute('data-url');

      this.setProductInfoTop(this.getProductInfoPosition());

      if (this.elements.successMessage) {
        this.elements.successMessage.classList.add('hidden');
      }
      this.elements.urlInput.setAttribute('value', url);
      this.elements.urlInput.classList.remove('is-copy');
    }

    copyToClipboard(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();

      if (!this.elements.urlInput || this.elements.urlInput.classList.contains('is-copy')) return;

      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        if (this.elements.successMessage) {
          this.elements.successMessage.setAttribute('aria-hidden', false);
        }
        this.elements.urlInput.setAttribute('value', 'Link copied to clipboard!');
        this.elements.urlInput.classList.add('is-copy');

        setTimeout(() => {
          if (this.elements.successMessage) {
            this.elements.successMessage.setAttribute('aria-hidden', true);
          }
        }, 6000);
      });
    }

    closeDetails(event) {
      event?.preventDefault && event.preventDefault();
      if (!this.elements.urlInput) return;
      const url = this.elements.urlInput.getAttribute('data-url');

      if (this.elements.successMessage) {
        this.elements.successMessage.classList.add('hidden');
      }
      this.elements.urlInput.setAttribute('value', url);
      this.elements.urlInput.classList.remove('is-copy');
      this.setProductInfoTop(0);
    }

    getProductInfoPosition() {
      const stickyElement = document.querySelector('.productView-details');
      if (!stickyElement || !stickyElement.parentNode) return 0;

      const stickyRect = stickyElement.getBoundingClientRect();
      const parentRect = stickyElement.parentNode.getBoundingClientRect();

      const topOffset = stickyRect.top - parentRect.top;
      return topOffset;
    }

    setProductInfoTop(top) {
      const productDetails = document.querySelector('.productView-details');
      if (productDetails && productDetails.style) {
        productDetails.style.setProperty('--sticky-top', top + 'px');
      }
    }
  }

  if (!customElements.get('share-button-product')) {
    customElements.define('share-button-product', ShareButtonProduct);
  }
  } catch(e) { console.error(e); }
})();

})();
